import React, { useState, useMemo } from "react";
import { Layout, Typography, Card, Row, Col, Tabs, Button, Input, Pagination } from "antd";
import { SearchOutlined } from "@ant-design/icons"; // Ant Design icons
import { FaComments, FaEye, FaThumbsUp } from "react-icons/fa"; // Correct import from react-icons

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;

const posts = [
  { id: 1, title: "How to Get Started with AI?", category: "AI", author: "Alice Mwangi", views: 120, likes: 15, comments: 8, date: "February 23, 2025" },
  { id: 2, title: "Best Practices in Cybersecurity", category: "Cybersecurity", author: "John Okech", views: 90, likes: 12, comments: 5, date: "February 22, 2025" },
  { id: 3, title: "Is Data Science a Good Career?", category: "Data Science", author: "Sophia Kalu", views: 150, likes: 22, comments: 10, date: "February 20, 2025" },
  { id: 4, title: "AI vs Data Science: What's the Difference?", category: "AI", author: "David Kimani", views: 180, likes: 30, comments: 15, date: "February 19, 2025" },
  { id: 5, title: "How to Get a Cybersecurity Job?", category: "Cybersecurity", author: "Fatima Hassan", views: 75, likes: 9, comments: 3, date: "February 16, 2025" },
  { id: 6, title: "Open Source AI Projects to Contribute To", category: "General", author: "Elijah Otieno", views: 200, likes: 35, comments: 20, date: "February 15, 2025" },
  { id: 7, title: "AI Ethics in Practice", category: "AI", author: "Nia Zulu", views: 130, likes: 18, comments: 7, date: "February 14, 2025" },
  { id: 8, title: "Data Visualization Tips", category: "Data Science", author: "Kofi Mensah", views: 110, likes: 14, comments: 6, date: "February 13, 2025" },
  { id: 9, title: "Securing IoT Devices", category: "Cybersecurity", author: "Amina Yusuf", views: 95, likes: 11, comments: 4, date: "February 12, 2025" },
  { id: 10, title: "AI Trends in 2025", category: "General", author: "James Otieno", views: 250, likes: 40, comments: 25, date: "February 11, 2025" },
];

const pageSize = 8;

const CommunityForum = () => {
  const [currentTab, setCurrentTab] = useState("AI");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");

  const handleTabChange = (key) => {
    setCurrentTab(key);
    setCurrentPage(1); // Reset to first page on tab change
    setSearchQuery(""); // Clear search on tab change
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1); // Reset to first page on new search
  };

  const filteredPosts = useMemo(() => {
    const query = searchQuery.toLowerCase();
    return posts.filter(
      (post) =>
        (post.category === currentTab || currentTab === "General") &&
        (post.title.toLowerCase().includes(query) || post.author.toLowerCase().includes(query))
    );
  }, [currentTab, searchQuery]);

  const paginatedPosts = useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return filteredPosts.slice(startIndex, startIndex + pageSize);
  }, [filteredPosts, currentPage]);

  return (
    <Layout>
      <Content style={{ padding: "50px", background: "#f0f2f5" }}>
        <Title level={2} style={{ fontSize: "24px", color: "#1890ff", textAlign: "center" }}>
          JectHub Community & Forum
        </Title>
        <Paragraph style={{ fontSize: "16px", color: "#666", textAlign: "center", marginBottom: "30px" }}>
          Engage with other learners, ask questions, and discuss topics in AI, Cybersecurity, and Data Science.
        </Paragraph>

        <Row gutter={[16, 16]} style={{ marginBottom: "24px" }}>
          <Col xs={24} md={12}>
            <Tabs
              defaultActiveKey="AI"
              onChange={handleTabChange}
              tabBarStyle={{ fontWeight: "bold", color: "#1890ff" }}
            >
              <TabPane tab="AI" key="AI" />
              <TabPane tab="Cybersecurity" key="Cybersecurity" />
              <TabPane tab="Data Science" key="Data Science" />
              <TabPane tab="General Discussions" key="General" />
            </Tabs>
          </Col>
          <Col xs={24} md={12}>
            <Input
              placeholder="Search posts by title or author"
              prefix={<SearchOutlined />}
              size="large"
              value={searchQuery}
              onChange={handleSearchChange}
              style={{ borderRadius: "4px" }}
            />
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          {paginatedPosts.length > 0 ? (
            paginatedPosts.map((post) => (
              <Col xs={24} sm={12} md={8} lg={6} key={post.id}>
                <Card
                  hoverable
                  style={{
                    borderRadius: "8px",
                    overflow: "hidden",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                  bodyStyle={{ padding: "16px" }}
                >
                  <Title level={4} style={{ marginBottom: "8px", color: "#333" }}>
                    <a href={`/community/${post.id}`} style={{ color: "#1890ff" }}>{post.title}</a>
                  </Title>
                  <Paragraph style={{ color: "#666", fontSize: "14px", marginBottom: "12px" }}>
                    By {post.author} | {post.date}
                  </Paragraph>
                  <div style={{ display: "flex", justifyContent: "space-between", color: "#666" }}>
                    <span><FaEye style={{ marginRight: "4px" }} /> {post.views}</span>
                    <span><FaThumbsUp style={{ marginRight: "4px" }} /> {post.likes}</span>
                    <span><FaComments style={{ marginRight: "4px" }} /> {post.comments}</span>
                  </div>
                </Card>
              </Col>
            ))
          ) : (
            <Col span={24} style={{ textAlign: "center" }}>
              <Paragraph style={{ color: "#999", fontSize: "16px" }}>
                No posts match your search or category. Try a different query or tab!
              </Paragraph>
            </Col>
          )}
        </Row>

        <Pagination
          current={currentPage}
          total={filteredPosts.length}
          pageSize={pageSize}
          onChange={setCurrentPage}
          style={{ marginTop: "24px", textAlign: "center" }}
          showSizeChanger={false}
        />

        <Button
          type="primary"
          href="/signin"
          style={{ marginTop: "24px", backgroundColor: "#1890ff", borderColor: "#1890ff", display: "block", marginLeft: "auto", marginRight: "auto" }}
        >
          Start a Discussion
        </Button>
      </Content>
    </Layout>
  );
};

export default CommunityForum;